var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{ref:"echars",staticClass:"echars-class"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }